// Local extraction for offline/IndexedDB. Worker also extracts server-side;
// both call sites import the same fn from @caliu/utils — see root AGENTS.md
// "Tag extraction: where it lives and why".
export {
  extractHashtags,
  stripCode,
  HASHTAG_REGEX,
  renameHashtagInContent,
  addHashtagToContent,
  removeHashtagFromContent,
} from '@caliu/utils'

import { extractHashtags, splitFrontmatterDocument } from '@caliu/utils'

/**
 * Hashtags for a FULL note document: frontmatter is stripped first so YAML
 * metadata (fold slugs, other clients' keys) can never mint tags. The autosave
 * pipeline persists the full document (frontmatter included) but must only
 * sync tags found in the body — this is the single helper enforcing that
 * invariant.
 */
export function extractBodyHashtags(content: string): string[] {
  return extractHashtags(splitFrontmatterDocument(content).body)
}
